/* unplugin-vue-components disabled */import script from "./Footer.vue?vue&type=script&setup=true&lang=ts"
export * from "./Footer.vue?vue&type=script&setup=true&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=6be117fc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6be117fc"]])

export default __exports__